/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type ListDatasetsPathParams = NonNullable<operations['listDatasets']['parameters']['path']>;

export type ListDatasetsQueryParams = NonNullable<operations['listDatasets']['parameters']['query']>;

export interface Input extends ListDatasetsPathParams {
  apiVersion?: string;
  query?: ListDatasetsQueryParams;
}

export async function listDatasets(
  { apiVersion, query, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/internal/projects/{projKey}/datasets', {
    params: { path, query },
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
